import { ChartOfAccount } from "@app/shared/classes/chart-of-account";
import {Transaction} from "@app/shared";

export class PoolBaseAccount {
  id: number;
  version: number;
  accountId: number;
  fiscalYearCostPoolId: number;
  account?: ChartOfAccount;
}

export class PoolAllocation {
  id?: number;
  version?: number;
  fiscalYearCostPoolId?: number;
  accountId?: number;
  accountName?: string;
  allocationValue?: number;
  allocationAmount?: number;
  offsetAccountId?: number;
  offsetAccountName?: string;
  appliedAccountId?: number;
  appliedAccountName?: string;
  offsetAccountNumber?: string;
  appliedAccountNumber?: string;
  accountNumber?: string;
}

export class IndirectRate {
  id: number;
  version: number;
  year: string;
  accountPeriodName: string;
  periodIndirectRate: number;
  periodPoolBalance: number;
  periodBaseBalance: number;
  ytdIndirectRate: number;
  ytdIndirectRateAsPercentage?: number;
  ytdPoolBalance: number;
  ytdBaseBalance: number;
  fiscalYearCostPoolId: number;
  accountingPeriodId: number;
  provisionalRateChangeId: number;
  costPoolName: string;
  accountingPeriodStart: string;
  accountingPeriodEnd: string;
  rateType: string;
  provisionalRateChangeName?: string;
  isProvisionalRate?: boolean;
  canModify?: boolean;
}
export class AppliedCostPool {
  id: number;
  version: number;
  accountId: number;
  costPoolId: number;
  appliedCostPoolId?: number;
  appliedCostPoolName?: string;
  costPoolName?: string;
  accountName?: string;
  appliedAccountId: number;
  offsetAccountId: number;
  appliedAccountName?: string;
  offsetAccountName?: string;
  offsetAccountNumber?: string;
  appliedAccountNumber?: string;
  accountNumber?: string;

  accountAssignmentType: string;
  fiscalYearCostPoolId: number;
}

export class FiscalYearCostPool {

  id: number;
  version: number;
  targetRate: number;
  forecastRate: number;
  provisionalRate: number;
  provisionalRateAsPercentage: number;
  ytdActualRate: number;
  ytdActualPoolBalance: number;
  ytdActualBaseBalance: number;
  year: string;
  poolAccounts: PoolBaseAccount[];
  baseAccounts: PoolBaseAccount[];
  poolAllocations: PoolAllocation[];
  appliedCostPool: AppliedCostPool[];
  indirectRates: IndirectRate[];
  costPoolId: number;
  costPoolName: string;
  costPoolDescription: string;
  costPoolType: string;
  allocationType: string;
}

export class CostPool {
  id: number;
  version: number;
  active: boolean;
  name: string;
  description: string;
  poolType: string;
  allocationType: string;
  fiscalYearCostPools: FiscalYearCostPool[];
  orgId: number;
  modelOptionId: number;
}

export class ProvisionalRateChange {
  id: number;
  version: number;
  year: string;
  name: string;
  accountingPeriodId: number;
  isClosedPeriod: boolean;
  status: ProvisionalRateChangeStatus;
  accountingPeriodName: string;
}

export class IndirectRateSummary {
  accountNumber: number;
  accountName: string;
  description: string;
  accountAssignmentType: string;
  balance: number;
  accountComponentType: string;
}

export class RateSummary {
  costPoolId: number;
  bidRateId?: number;
  bidRateVersion?: number;
  fiscalYearCostPoolId?: number;
  accountingPeriodId?: number;
  contractModId?: number;
  costPoolName?: string;
  poolType: CostPoolType;
  bidRate?: number;
  bidRateAsPercentage?: number;
  provisionalRate?: number;
  actualRate?: number;

  transaction?: Transaction;
  refId?: number;
}

export class BidRate {

  id: number;
  version: number;

  rate: number;
  orgId: number;
  accountingPeriodId: number;
  contractBidId: number;
  contractId: number;
  projectId: number;
  contractModId: number;
  costPoolId: number;

  costPoolName: string;
  accountingPeriodStart: string;
  bidRateAsPercentage: number;
}
export class BidRateModHistory {
  bidRateId: number;
  bidRate: number;
  accountingPeriodStart: string;
  accountingPeriodAsString: string;
  modEffectiveOn: string;
  modNumber: string;
}


export enum CostPoolType {
  Direct = 'DIRECT',
  Fringe = 'FRINGE',
  GeneralAdmin = 'GENERAL_ADMIN',
  MatHandling = 'MAT_HANDLING',
  Overhead = 'OVERHEAD',
  AllocationCenter = 'ALLOCATION_CENTER',
  Unallowable = 'UNALLOWABLE'
}

export enum ProvisionalRateChangeStatus {
  Saved = 'SAVED',
  Inprogress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Error = 'ERROR'
}

export enum Source {
  DefaultSetup = 'DEFAULT_SETUP',
  OrgSetup = 'ORG_SETUP'
}

export enum AccountAssignmentType {
  Pool = 'POOL',
  Base = 'BASE'
}

export enum AccountComponentType {
  Pool = 'POOL',
  Base = 'BASE',
  AppliedCostPool = 'APPLIED_COST_POOL',
  AllocationCenter = 'ALLOCATION_CENTER'
}